<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpclaveunidadpeso" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCpClaveUnidadPeso.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Descripcion">Descripcion</label>
							<textarea v-model="objCpClaveUnidadPeso.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Descripcion" rows="3"></textarea>
							<CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpClaveUnidadPeso.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nota">Nota</label>
							<textarea v-model="objCpClaveUnidadPeso.Nota" class="form-control" id="Nota" placeholder="Ingresar Nota" rows="3"></textarea>
							<CValidation v-if="this.errorvalidacion.Nota" :Mensaje="'*'+errorvalidacion.Nota[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Simbolo">Simbolo</label>
							<input type="text" v-model="objCpClaveUnidadPeso.Simbolo" class="form-control" id="Simbolo" placeholder="Ingresar Simbolo" />
							<CValidation v-if="this.errorvalidacion.Simbolo" :Mensaje="'*'+errorvalidacion.Simbolo[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="IdBandera">Bandera</label>
							<select v-model="objCpClaveUnidadPeso.IdBandera" class="form-control-search form-select" id="IdBandera">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in ListaBanderaUnidades" :key="index" :value="item.IdBandera">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdBandera" :Mensaje="'*'+errorvalidacion.IdBandera[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpclaveunidadpeso',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpClaveUnidadPeso: {
				IdClaveUnidadPeso: 0,
				Nombre: '',
				Descripcion: '',
				Clave: '',
				Nota: '',
				Simbolo: '',
				IdBandera: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			ListaBanderaUnidades: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpClaveUnidadPeso.IdClaveUnidadPeso == 0) {
				await this.$http.post(
					'cpClavesUnidadesPeso',this.objCpClaveUnidadPeso
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpClavesUnidadesPeso/'+this.objCpClaveUnidadPeso.IdClaveUnidadPeso,
					this.objCpClaveUnidadPeso
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpClavesUnidadesPeso/"+this.objCpClaveUnidadPeso.IdClaveUnidadPeso
            ).then((res) => {
                this.objCpClaveUnidadPeso = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpClaveUnidadPeso.Fecha.replace(/-/g,'\/');
                this.objCpClaveUnidadPeso.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpClaveUnidadPeso = {
				IdClaveUnidadPeso: 0,
				Nombre: '',
				Descripcion: '',
				Clave: '',
				Nota: '',
				Simbolo: '',
				IdBandera: '',
            }
            this.errorvalidacion = [];
        },
		GetListaBanderaUnidades()
		{
			this.$http.get("cpBanderaUnidades", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.ListaBanderaUnidades = res.data.data;
			});
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

			this.GetListaBanderaUnidades();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpClaveUnidadPeso.IdClaveUnidadPeso = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
